/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'target': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<path pid="0" d="M10 4a1 1 0 010 2 4 4 0 104 4 1 1 0 012 0 6 6 0 11-6-6zm7-4v3h3l-4 4h-1.5l-2.55 2.55c.05.15.05.3.05.45a2 2 0 11-2-2c.15 0 .3 0 .45.05L13 5.5V4l4-4zm1.007 9.883a1 1 0 011.987 0L20 10a10 10 0 01-20 0C0 4.477 4.477 0 10 0a1 1 0 010 2 8 8 0 107.996 8.25L18 10z" _fill="#2CB6F8" fill-rule="evenodd"/>'
  }
})
